import styled from 'styled-components';
export var Svg = styled.svg.withConfig({
  componentId: "sc-10ui8rt-0"
})(["transform-origin:center;transform:scaleY(", ");transition:transform ease-in 0.2s;"], function (props) {
  return props.active ? '-1' : '1';
});